import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import axios from 'axios'
import toastStore from '@/stores/toast-store.js'

export default {
  name: 'DeliveryQrModal',
  extends: BaseModal,
  data: function () {
    return {
      qrCode: null,
      blocker: false,
    }
  },
  mounted() {
    this.fetchQr()
  },
  methods: {
    fetchQr() {
      this.blocker = true

      let url = ''
      if (this.data.hasDeliveryEnded) {
        url = `delivery_requests/${this.data.id}/collection_qr?data_url=1`
      } else {
        url = `delivery_requests/${this.data.id}/delivery_qr?data_url=1`
      }

      axios({
        method: 'get',
        url: url,
      })
        .then(response => {
          this.qrCode = response.data
          console.log('fetchQr response', response.data)
        })
        .catch(error => {
          console.error('fetchQr error', error.response)
        })
        .finally(() => {
          this.blocker = false
        })
    },

    copyQR() {
      const el = document.createElement('textarea')
      el.value = 'test url'
      document.body.appendChild(el)

      if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
        var editable = el.contentEditable
        var readOnly = el.readOnly

        el.contentEditable = true
        el.readOnly = true

        var range = document.createRange()
        range.selectNodeContents(el)

        var selection = window.getSelection()
        selection.removeAllRanges()
        selection.addRange(range)
        el.setSelectionRange(0, 999999)

        el.contentEditable = editable
        el.readOnly = readOnly
      } else {
        el.select()
      }

      document.execCommand('copy')
      document.body.removeChild(el)
      toastStore.commit('success', { message: this.$t('general.qrCodeLinkCopied') })
    },

    downloadQR() {
      this.$refs.link.click()
      toastStore.commit('success', { message: this.$t('general.qrCodeDownloaded') })
    },

    dataURItoBlob(dataURI) {
      var byteString = atob(dataURI.split(',')[1])
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
      var ab = new ArrayBuffer(byteString.length)
      var ia = new Uint8Array(ab)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }
      var blob = new Blob([ab], { type: mimeString })
      return blob
    },
  },
  components: {
    Blocker: () => import('@/vcs/_shared/blocker/cmp.vue'),
  },
}
